export enum RequisitionTypes {
    NONE = '',
    REQUEST = 'Solicitud',
    PROVISIONAL_INCREMENT = 'Aumento Prestacional',
    AUTHORIZATION = 'Autorización',
    PARTIAL_DISCHARGE = 'Baja Parcial',
    ENDING = 'Finalización'
}